import React from "react"
import { FaStar } from "react-icons/fa"
import styles from "../styles/components/rating.module.scss"

const Rating = ({ rating }) => {
  const value = Math.min(5, Math.max(0, Number(rating) || 0))
  const stars = Array.from({ length: 5 }, (_, index) => <FaStar key={index} />)
  return (
    <div className={styles.starsOuter} role="img" aria-label={`${value} out of 5 stars`}>
      <span className={styles.row} aria-hidden="true">{stars}</span>
      <span className={styles.starsInner} style={{ width: `${value / 5 * 100}%` }} aria-hidden="true">
        <span className={styles.row}>{stars}</span>
      </span>
    </div>
  )
}
export default Rating
